import { Segment } from "@lookiero/sty-psp-segment";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { MenSizeGuideModal } from "../components/segment/men/MenSizeGuideModal";
import { LookieroWomenSizeGuideModal } from "../components/segment/women/LookieroWomenSizeGuideModal";
import { OutfitteryWomenSizeGuideModal } from "../components/segment/women/OutfitteryWomenSizeGuideModal";
const SIZE_GUIDE_MODAL_BY_TRADENAME = {
    [Tradename.LOOKIERO]: LookieroWomenSizeGuideModal,
    [Tradename.OUTFITTERY]: OutfitteryWomenSizeGuideModal,
};
const SIZE_GUIDE_MODAL_BY_SEGMENT = {
    [Segment.MEN]: MenSizeGuideModal,
};
const getSizeGuideModalBySegmentAndTradename = ({ segment, tradename, }) => SIZE_GUIDE_MODAL_BY_SEGMENT[segment] || SIZE_GUIDE_MODAL_BY_TRADENAME[tradename];
export { getSizeGuideModalBySegmentAndTradename };
